import React from "react";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function GeneralSerialsUpload({
  onUpload,
  fileList,
  setFileList,
  loading,
}) {
  return (
    <div style={{ margin: "16px 0" }}>
      <Upload
        accept=".txt"
        beforeUpload={async (file) => {
          await onUpload(file);
          return false; // Previene el POST automático
        }}
        fileList={fileList}
        onChange={({ fileList }) => setFileList(fileList)}
        showUploadList={true}
        customRequest={() => {}} 
      >
        <Button icon={<UploadOutlined />} type="primary" loading={loading}>
          Subir archivo de seriales (general)
        </Button>
      </Upload>
    </div>
  );
} 